import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';
import { UserData } from '../interface/user';
import { ROLE } from '../enum/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  user = this.storageService.getItem('user');
  constructor(
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserLogin(next, state);
  }

  checkUserLogin(route: ActivatedRouteSnapshot, state): boolean {
    if (this.authService.isLoggedIn()) {
      const userRole = this.authService.getRole();

      if (
        route.data.role === ROLE.ADMIN &&
        !this.storageService.checkUserRole(userRole, 'admin')
      ) {
        this.router.navigate(['/calendar']);
        return false;
      }

      if (route.data.role === 'super-admin' && userRole !== 19) {
        this.router.navigate(['/calendar']);
        return false;
      }

      if (
        this.user?.user?.school?.schoolData?.isStudentMessageAccess === false &&
        this.storageService.checkUserRole(this.user.user.role_id, 'student') &&
        state.url.includes('messaging')
      ) {
        this.router.navigate(['/calendar']);
        return false;
      }
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
